/*
 * Ryan O'Dowd
 * 2025-05-26
 * © Copyright 2025 Oakwood Software Consulting, Inc.  All Rights Reserved.
 */
import routing from '@utils/routing';
import {
  useMemo,
} from 'react';

export default function useNavigation() {
  const navigation: any = routing.useNavigate();
  const [__searchParams, setSearchParams] = routing.useSearchParams();

  return useMemo(() => {
    return {
      navigate: (path: string, routeParams = undefined) => navigation(path, {state: routeParams}), // @TODO: should be able to handle route params
      goBack: () => navigation(-1),
      replace: (url, params=undefined) => {
        navigation(url, {replace: true, state: params});
        setTimeout(() => {
          window.location.href = window.location.href; /* eslint-disable-line no-self-assign */
        }, 0); // @NOTE: required due to a race condition with react-router not update the url or internal state yet
      },
      setParams: (params, replace = true) => {
        const filteredParams = new URLSearchParams();
        for (const [key, value] of Object.entries(params)) {
          if (value) {
            filteredParams.set(key, value as any); // @TODO: guarantee that value is a string
          }
        }
        setSearchParams(filteredParams, {replace});
      },
      pop: () => navigation(-1), // @TODO: this is only here for the usage in CustomAuthForm/index.tsx that's native only but throwing tsc error
    };
  }, [navigation, setSearchParams]);
}
